var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGameHard = function SvgGameHard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "game_hard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6145a",
    d: "M0 0h33.738v51.274H0z",
    "data-name": "Rectangle 853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "game_hard_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6145a",
    d: "M0 0h59.821v21.511H0z",
    "data-name": "Rectangle 854"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gaming diff-hard"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2829"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2821"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2736"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2735"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#game_hard_svg__a)",
    "data-name": "Group 2734",
    transform: "translate(44.462 3.093)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6145a",
    d: "M-.001 9.493a1.86 1.86 0 0 0 1.508 1.805 26.64 26.64 0 0 1 21.058 26 26.2 26.2 0 0 1-1.177 7.731 1.85 1.85 0 0 0 .823 2.179l6.6 3.809a1.877 1.877 0 0 0 2.7-.937 37.6 37.6 0 0 0 2.228-12.782A37.84 37.84 0 0 0 2.139.023a1.873 1.873 0 0 0-2.14 1.866Z",
    "data-name": "Path 6081"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#f6145a",
    d: "M14.492 51.278a1.85 1.85 0 0 0 .766-2.213 26.57 26.57 0 0 1 20.2-34.807 1.855 1.855 0 0 0 1.55-1.813V4.893a1.876 1.876 0 0 0-2.11-1.874A37.83 37.83 0 0 0 2.624 40.39a37.4 37.4 0 0 0 2.7 13.936 1.867 1.867 0 0 0 2.7.861Z",
    "data-name": "Path 6082"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2739"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2738"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#game_hard_svg__b)",
    "data-name": "Group 2737",
    transform: "translate(10.881 56.668)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f6145a",
    d: "M52.341.244a1.85 1.85 0 0 0-2.365.461 26.512 26.512 0 0 1-40.264.735 1.864 1.864 0 0 0-2.358-.389L.921 4.936a1.875 1.875 0 0 0-.514 2.773 37.675 37.675 0 0 0 59.044-.948 1.878 1.878 0 0 0-.583-2.746Z",
    "data-name": "Path 6083"
  })))))))));
};
export default SvgGameHard;